"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f121 = void 0;
exports.f121 = {
    "yemeni": [
        73,
        583
    ],
    "ye": [
        5253,
        7321,
        7796,
        73,
        434,
        579,
        583,
        2591,
        3220,
        6649,
        7084,
        7085,
        8614,
        8627
    ],
    "yemen": [
        73,
        434,
        579,
        583,
        2591,
        3220,
        6649,
        7084,
        7085,
        8614,
        8627
    ],
    "yum": [
        166
    ],
    "yani": [
        181,
        182,
        183,
        184,
        185
    ],
    "yerawa": [
        241
    ],
    "yowera": [
        280
    ],
    "yora": [
        5119,
        287
    ],
    "yanesha’": [
        288
    ],
    "yaneshaʼ": [
        288
    ],
    "yanesha'": [
        288
    ],
    "yauan": [
        349
    ],
    "ytangá": [
        450
    ],
    "yauri": [
        466
    ],
    "yaosakor": [
        483
    ],
    "yaosakor asmat": [
        483
    ],
    "yopngadi": [
        550
    ],
    "yupangathi": [
        550
    ],
    "yupangati": [
        550
    ],
    "yupnget": [
        550
    ],
    "yupun-gatti": [
        550
    ],
    "yupungati": [
        550
    ],
    "yuupngati": [
        550
    ],
    "yěbù": [
        556
    ],
    "yenimu": [
        558,
        564
    ],
    "yaringa": [
        566
    ],
    "yaroinga": [
        566
    ],
    "yarroinga": [
        566
    ],
    "yarrowin": [
        566
    ],
    "yorrawinga": [
        566
    ],
    "yorrowinga": [
        566
    ],
    "yuruwinga": [
        566
    ],
    "yaka": [
        568,
        3298,
        8722,
        3745,
        8745
    ],
    "yaka (central african republic)": [
        568
    ],
    "yaâkâ": [
        568
    ],
    "yigha": [
        580
    ],
    "yovai": [
        584
    ],
    "yanaigua": [
        584,
        7667
    ],
    "yi": [
        8949,
        8950,
        1318,
        8882,
        598,
        3169,
        3170,
        5634,
        5684,
        8761,
        8797,
        8811,
        8812,
        8835,
        8858,
        8909,
        8913,
        8952,
        8953
    ],
    "y": [
        4235,
        605,
        4824,
        5206,
        5226,
        6051,
        9166
    ],
    "yavita": [
        613,
        4784
    ],
    "yambassa": [
        8738,
        614,
        2084,
        4920,
        8741
    ],
    "yüng": [
        624
    ],
    "yong": [
        8865,
        624
    ],
    "yibarambu": [
        640
    ],
    "yu": [
        3283,
        3284,
        3285,
        3286,
        3287,
        8225,
        641,
        928,
        929,
        930,
        931,
        5678,
        6201
    ],
    "yunnan bai": [
        660,
        661
    ],
    "yunnan": [
        660,
        661,
        7386,
        7387,
        2973,
        2974,
        2975
    ],
    "yadena": [
        697
    ],
    "yedana": [
        697
    ],
    "yedima": [
        697
    ],
    "yedina": [
        697
    ],
    "yedǝnami": [
        697
    ],
    "yidana": [
        697
    ],
    "yidena": [
        697
    ],
    "yangura": [
        726
    ],
    "yarahmadza": [
        790,
        791
    ],
    "yigai": [
        865
    ],
    "yakoro": [
        906
    ],
    "yao": [
        8733,
        8734,
        4341,
        4342,
        963,
        1037,
        3283,
        3284,
        3285,
        3286,
        3287,
        4220,
        4824,
        6244,
        8898
    ],
    "yambiyambi": [
        993
    ],
    "yembiyembi": [
        993
    ],
    "yao min": [
        1037
    ],
    "yau min": [
        1037
    ],
    "yau": [
        8939,
        8962,
        1037,
        1751,
        7608,
        4039
    ],
    "yukutare": [
        1099
    ],
    "yae": [
        3346,
        3347,
        1129
    ],
    "yebamasa": [
        1129
    ],
    "yepa-mahsa": [
        1129
    ],
    "yepa-matso": [
        1129
    ],
    "yangkam": [
        1142
    ],
    "yankam": [
        1142
    ],
    "yt": [
        1172,
        2465,
        7228,
        7229
    ],
    "younuo": [
        1179
    ],
    "younuo bunu": [
        1179
    ],
    "yuno": [
        1179
    ],
    "yunuo": [
        1179
    ],
    "yom gawac": [
        1182
    ],
    "yom": [
        6152,
        1182
    ],
    "yavitero": [
        8944,
        1216
    ],
    "yere": [
        1231
    ],
    "yung-ts’ung miao": [
        1245
    ],
    "yung-ts’ung": [
        1245
    ],
    "yaleba": [
        8828,
        1255
    ],
    "yipma": [
        1289
    ],
    "yɨ'mayagaala": [
        1289
    ],
    "yɨ’mayagaala": [
        1289
    ],
    "yangoru": [
        1302
    ],
    "yengoru": [
        1302
    ],
    "yuwibara": [
        1314
    ],
    "yi be wu": [
        1318
    ],
    "yuri": [
        1370,
        8930
    ],
    "yocot'an": [
        1441
    ],
    "yocot’an": [
        1441
    ],
    "yidu": [
        1521,
        1520
    ],
    "yangpan": [
        1547
    ],
    "yas": [
        1554
    ],
    "yuman": [
        1562,
        4978,
        8927
    ],
    "york cree": [
        1614,
        1652
    ],
    "york": [
        1614,
        1652,
        6462,
        7371
    ],
    "yojwaja": [
        1617
    ],
    "yofuaha": [
        1620
    ],
    "yowúwa": [
        1620
    ],
    "ysleño": [
        1626
    ],
    "ya": [
        1694,
        5188,
        1919,
        1920,
        7877,
        8748,
        8749,
        4001,
        7879
    ],
    "yuanxin hongjin dai": [
        1694
    ],
    "yuanxin": [
        1694
    ],
    "yotun": [
        1718
    ],
    "yindu": [
        1738
    ],
    "yari": [
        1816
    ],
    "yatıì": [
        1826
    ],
    "yolngu-matha": [
        1833
    ],
    "yuulngu": [
        1833
    ],
    "yaara": [
        1868
    ],
    "yaura": [
        1868
    ],
    "yacouba": [
        1919,
        1920
    ],
    "yakuba": [
        1919,
        1920
    ],
    "yoa-lokpa": [
        1943
    ],
    "yille": [
        1993
    ],
    "yuna": [
        1997
    ],
    "yabatia": [
        2004
    ],
    "yag dii": [
        2011
    ],
    "yag": [
        2011
    ],
    "ya̧g dìì": [
        2011
    ],
    "ya̧g": [
        2011
    ],
    "yolngu": [
        8787,
        2027
    ],
    "yanda": [
        8764,
        2036
    ],
    "yanda dom": [
        2036
    ],
    "yanda dom dogon": [
        2036
    ],
    "yola": [
        8877,
        2038,
        2039
    ],
    "yangtsebikha": [
        2048
    ],
    "yace": [
        2088
    ],
    "yache": [
        2088
    ],
    "yatye": [
        2088
    ],
    "yunan": [
        2090,
        2091,
        2093
    ],
    "yupik, pacific gulf": [
        2111,
        2112
    ],
    "yupik": [
        2111,
        2112,
        2297,
        2298,
        2299,
        8862,
        8911
    ],
    "yenisei samoyedic": [
        2231,
        2232
    ],
    "yenisei": [
        2231,
        2232,
        3577,
        3705
    ],
    "yupik, saint lawrence island": [
        2297,
        2298
    ],
    "yoit": [
        2297,
        2298
    ],
    "yuit": [
        2297,
        2298
    ],
    "yuitsky": [
        2297,
        2298
    ],
    "yuk": [
        2297,
        2298
    ],
    "yupigestun": [
        2297,
        2298
    ],
    "yupik, central siberian": [
        2297,
        2298
    ],
    "yupik, central": [
        2299
    ],
    "yugtun": [
        2299
    ],
    "yupʼik": [
        2299
    ],
    "yekhee": [
        2310
    ],
    "yaounde": [
        2323
    ],
    "yaunde": [
        2323
    ],
    "yes bèfɨràn": [
        2390
    ],
    "yes": [
        2390
    ],
    "yimtim": [
        2398
    ],
    "yalgawarra": [
        2400
    ],
    "yaathe": [
        2492
    ],
    "yahthe": [
        2492
    ],
    "yatê": [
        2492
    ],
    "yatê-fulniô": [
        2492
    ],
    "yerge": [
        2500
    ],
    "yehen": [
        2501
    ],
    "yengen": [
        2501
    ],
    "yamma": [
        2563
    ],
    "yangarella": [
        2566,
        5615
    ],
    "yokula": [
        2566
    ],
    "yookala": [
        2566,
        8788
    ],
    "yugulda": [
        2566
    ],
    "yukala": [
        2566
    ],
    "yukula": [
        2566
    ],
    "yukulta": [
        2566
    ],
    "yukulta-nguburindi": [
        2566
    ],
    "yagele": [
        2602
    ],
    "ywom": [
        2606
    ],
    "yioum": [
        2606
    ],
    "yiwom": [
        2606
    ],
    "yathu gekho": [
        2631
    ],
    "yathu": [
        2631
    ],
    "yotubo": [
        2695
    ],
    "yawaim": [
        2718
    ],
    "yeretuar": [
        2743
    ],
    "yutong": [
        2757
    ],
    "yerani": [
        2774
    ],
    "yankowan": [
        2793
    ],
    "yocoboué": [
        2806
    ],
    "yocoboué dida": [
        2806
    ],
    "yanomamö": [
        2822
    ],
    "yanoama": [
        2822,
        8194
    ],
    "yanoamae": [
        2822
    ],
    "yanoamï": [
        2822
    ],
    "yanomae": [
        2822
    ],
    "yanomam": [
        2822,
        8194
    ],
    "yanomame": [
        2822
    ],
    "yanomami": [
        2822
    ],
    "yanomamï": [
        2822,
        8194
    ],
    "yanomamɨ": [
        2822
    ],
    "yalandyi": [
        2834
    ],
    "yalanji": [
        2834
    ],
    "yáá mòò": [
        2847
    ],
    "yáá": [
        2847
    ],
    "yoliapi": [
        2897
    ],
    "yue": [
        8923,
        8924,
        8925,
        8926,
        2963
    ],
    "yenbai": [
        2977
    ],
    "yazyk": [
        3104,
        3105,
        3452,
        3453,
        3454,
        6619,
        6620,
        7547,
        7548
    ],
    "yai": [
        3111,
        6062,
        6063,
        6845,
        6846,
        6847,
        6848
    ],
    "yiwaidja": [
        3117
    ],
    "ybanag": [
        3119
    ],
    "yanderika": [
        3140
    ],
    "yandirika": [
        3140
    ],
    "yi-nuosu": [
        3169,
        3170
    ],
    "ylanos": [
        3197
    ],
    "yate": [
        3222
    ],
    "ynezeño": [
        3226
    ],
    "yeresiam": [
        3235
    ],
    "yirigwe": [
        3237
    ],
    "yiir": [
        3240
    ],
    "yir": [
        3240,
        8897,
        8961
    ],
    "yawuno teneyo": [
        3273
    ],
    "yawuno": [
        3273
    ],
    "yinibu": [
        3273
    ],
    "yao kimmien": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "yao mienh": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "yao ogang": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "yiu mien": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "yiu": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "youmian": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "yu mien": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "yawenian": [
        3293
    ],
    "yaa": [
        3298
    ],
    "yaka (congo)": [
        3298
    ],
    "yamadi": [
        3305
    ],
    "yamamadí": [
        3305
    ],
    "yamamandi": [
        3305
    ],
    "yabem": [
        3309
    ],
    "yabim": [
        3309
    ],
    "yalahatan": [
        3314
    ],
    "yalahatan-haruru-awaiya": [
        3314
    ],
    "yanyuwa": [
        3317
    ],
    "yanula": [
        3317
    ],
    "yanuwa": [
        3317
    ],
    "yanyula": [
        3317
    ],
    "yaqay": [
        3318
    ],
    "yaqai": [
        3318
    ],
    "yaur": [
        3321
    ],
    "yan-nhangu": [
        3323,
        8793
    ],
    "yanangu": [
        3323
    ],
    "yaban": [
        3327
    ],
    "yabutí": [
        3333
    ],
    "yawijibaya": [
        3335
    ],
    "yaudjibaia": [
        3335
    ],
    "yaudjibara": [
        3335
    ],
    "yaujibaia": [
        3335
    ],
    "yawjibara": [
        3335
    ],
    "yawjibarra": [
        3335
    ],
    "yaeh": [
        3346,
        3347
    ],
    "yeh": [
        3346,
        3347
    ],
    "yei": [
        3348,
        8780,
        9016
    ],
    "yei-nan": [
        3348
    ],
    "yey": [
        3348
    ],
    "yelmek": [
        3350
    ],
    "yeti": [
        3353
    ],
    "yilbe": [
        3366
    ],
    "youle": [
        3375
    ],
    "youle jinuo": [
        3375
    ],
    "yamdena": [
        3392
    ],
    "yangman": [
        3402
    ],
    "yung munni": [
        3402
    ],
    "yung": [
        3402
    ],
    "yungman": [
        3402
    ],
    "yungmanni": [
        3402
    ],
    "yungmun": [
        3402
    ],
    "yungmunee": [
        3402
    ],
    "yungmunnee": [
        3402
    ],
    "yungmunni": [
        3402
    ],
    "yemsa": [
        3404,
        3405
    ],
    "yapreria": [
        3424
    ],
    "yumá": [
        3426
    ],
    "yilrea": [
        3431,
        8222
    ],
    "youngye": [
        3431
    ],
    "yudjá": [
        3438
    ],
    "yudya": [
        3438
    ],
    "yurúna": [
        3438
    ],
    "yemenite": [
        3450
    ],
    "yemenite judeo-arabic": [
        3450
    ],
    "yeminite": [
        3450
    ],
    "yaya": [
        3451
    ],
    "yaldiye-ho": [
        3482
    ],
    "yamegi": [
        3518
    ],
    "yon": [
        3525
    ],
    "yankunytjatjara": [
        3534
    ],
    "yangkundjara": [
        3534
    ],
    "yankuntatjara": [
        3534
    ],
    "yankuntjara": [
        3534
    ],
    "yankuntjatjara": [
        3534
    ],
    "yankuntjatjarra": [
        3534
    ],
    "yimwom": [
        3555
    ],
    "yega": [
        3560
    ],
    "yenisei ostyak": [
        3577
    ],
    "yenisey ostiak": [
        3577
    ],
    "yenisey": [
        3577
    ],
    "yenisey ostyak": [
        3577
    ],
    "yanuskad": [
        3601,
        3602
    ],
    "yimbun": [
        3635
    ],
    "yakusu": [
        3668
    ],
    "yanzi": [
        3689,
        8867
    ],
    "yotowawa": [
        3700
    ],
    "yenisei tatar": [
        3705
    ],
    "yennisej tatar": [
        3705
    ],
    "yennisej": [
        3705
    ],
    "yǔyán": [
        3728,
        3730,
        3731,
        3733
    ],
    "yale, kosarek": [
        3748
    ],
    "yale": [
        3748,
        5338
    ],
    "yale yubu": [
        3748
    ],
    "yubu": [
        3748
    ],
    "yale-kosarek": [
        3748
    ],
    "yali": [
        5550,
        8719,
        8831,
        3748
    ],
    "yali kosarek": [
        3748
    ],
    "yimidhirr": [
        3761
    ],
    "yimijir": [
        3761
    ],
    "yimithirr": [
        3761
    ],
    "yaali": [
        3769
    ],
    "yabin": [
        3823,
        5404
    ],
    "yabin-konda": [
        3823
    ],
    "yamale": [
        3870
    ],
    "yamalo": [
        3870
    ],
    "ynã": [
        3883
    ],
    "yorda": [
        3884
    ],
    "yerwa": [
        3926,
        3925
    ],
    "yerwa kanuri": [
        3925,
        3926
    ],
    "yofo": [
        3966
    ],
    "yang khao": [
        3976,
        3977
    ],
    "yang": [
        9181,
        3976,
        3977,
        4152,
        4153,
        4154,
        6062,
        6063,
        7372,
        8804,
        8898,
        6523
    ],
    "yonggom": [
        3990,
        3999,
        8879
    ],
    "yongkom": [
        8879,
        3990,
        3999
    ],
    "yongom": [
        3990,
        3999,
        8879
    ],
    "ya’u": [
        4039
    ],
    "ya’o": [
        4039
    ],
    "yan wohta": [
        4065
    ],
    "yan": [
        4065,
        8596
    ],
    "yinbaw": [
        4066
    ],
    "yeinbaw": [
        4066
    ],
    "yinbaw karen": [
        4066
    ],
    "yintale": [
        4070
    ],
    "yangatalet": [
        4070
    ],
    "yangtadai": [
        4070
    ],
    "yintale karen": [
        4070
    ],
    "yintalet": [
        4070
    ],
    "yoncalla": [
        4143
    ],
    "yang daeng": [
        4152,
        4153,
        4154
    ],
    "yrou": [
        4231
    ],
    "yakkhaba khap": [
        4233,
        8751
    ],
    "yakkhaba": [
        4233,
        4537,
        8750,
        8751
    ],
    "yakkhaba lorung": [
        4233
    ],
    "y mia": [
        4235
    ],
    "y poong": [
        4235
    ],
    "y pí": [
        4235
    ],
    "y póng": [
        4235
    ],
    "y to": [
        4235
    ],
    "yellow lahu": [
        4315
    ],
    "yellow": [
        4315,
        5039,
        5604,
        8748,
        8749,
        8941
    ],
    "yimba": [
        4324,
        4393
    ],
    "yumba": [
        4324,
        4393
    ],
    "yakthung pan": [
        4329,
        4330
    ],
    "yakthung": [
        4329,
        4330
    ],
    "yakthungpan": [
        4329,
        4330
    ],
    "yao yen": [
        4341,
        4342
    ],
    "yen": [
        4341,
        4342
    ],
    "yaw yin": [
        4341,
        4342
    ],
    "yaw": [
        4341,
        4342
    ],
    "yin": [
        6523,
        8804,
        4341,
        4342
    ],
    "yaw-yen": [
        4341,
        4342
    ],
    "yeh-jeh": [
        4341,
        4342
    ],
    "yeh-jen": [
        4341,
        4342
    ],
    "yirandali": [
        4355
    ],
    "yerrundulli": [
        4355
    ],
    "yerrunthully": [
        4355
    ],
    "yirandhali": [
        4355
    ],
    "yuru": [
        4356
    ],
    "yangeeberra": [
        4372,
        8708
    ],
    "yankibura": [
        4372
    ],
    "yurlayurlanya": [
        4437
    ],
    "yillaro": [
        4484
    ],
    "yamphu, southern": [
        4485
    ],
    "yamphu": [
        4485,
        8751
    ],
    "yilumbu": [
        4530
    ],
    "yakkha, chhathare": [
        4537
    ],
    "yakkha": [
        4537,
        8750
    ],
    "yakkhaba cea": [
        4537,
        8750
    ],
    "yutanduchi": [
        4572
    ],
    "yutanduchi mixtec": [
        4572
    ],
    "yĩyax": [
        4610
    ],
    "yĩy’ax": [
        4610
    ],
    "yoadabe-watoare": [
        4621
    ],
    "yecuana": [
        4632
    ],
    "yekuana": [
        4632
    ],
    "yekuána": [
        4632
    ],
    "yekwana": [
        4632
    ],
    "ye’cuana": [
        4632
    ],
    "ye’kuana": [
        4632
    ],
    "ye’kwana": [
        4632
    ],
    "yidda": [
        4651
    ],
    "yosonotú": [
        4673
    ],
    "yalmbau": [
        4691
    ],
    "yia": [
        4692,
        4693
    ],
    "yawi": [
        4707,
        4708,
        7708
    ],
    "yoreme nokki": [
        4734
    ],
    "yoreme": [
        4734
    ],
    "yaako": [
        4773
    ],
    "yako": [
        4773
    ],
    "yuba": [
        4820
    ],
    "yiboia-tapuya": [
        4921
    ],
    "yibóya-tapúya": [
        4921
    ],
    "yosondúa": [
        4996
    ],
    "yosondúa mixtec": [
        4996
    ],
    "yellow leaf": [
        5039
    ],
    "yumbri": [
        5039
    ],
    "yucatec maya sign language": [
        5076
    ],
    "yucatec": [
        5076,
        8919
    ],
    "yoranahua": [
        5119
    ],
    "yura": [
        5119,
        8942
    ],
    "yurahahua": [
        5119
    ],
    "yapeli": [
        5138
    ],
    "yaaku": [
        5144
    ],
    "yaakua": [
        5144
    ],
    "yiaku": [
        5144
    ],
    "yiakunte": [
        5144
    ],
    "yucuañe": [
        5157
    ],
    "yucuañe mixtec": [
        5157
    ],
    "yagaw": [
        5188
    ],
    "yagar yagar": [
        5188
    ],
    "yagar": [
        5188
    ],
    "yucuná": [
        5205
    ],
    "yeba": [
        5253
    ],
    "yeba-masã": [
        5253
    ],
    "yebamasã": [
        5253
    ],
    "yehpá majsá": [
        5253
    ],
    "yehpá": [
        5253
    ],
    "yepá maxsã": [
        5253
    ],
    "yepá": [
        5253
    ],
    "yepá-mahsá": [
        5253
    ],
    "yoro": [
        5268
    ],
    "yalë": [
        5338
    ],
    "yadë": [
        5338
    ],
    "yarë": [
        5338
    ],
    "yarete": [
        5398
    ],
    "yahadian": [
        5404
    ],
    "yabin yahadian": [
        5404
    ],
    "yaheun": [
        5408
    ],
    "yali, ninia": [
        5550
    ],
    "yali selatan": [
        5550
    ],
    "yarluyandji": [
        5585
    ],
    "yellow river": [
        5604
    ],
    "yanggal": [
        5615
    ],
    "yangkaal": [
        5615
    ],
    "yuckamurri": [
        5615
    ],
    "yurt tatar": [
        5624
    ],
    "yurt": [
        5624,
        8960
    ],
    "yale-nipsan": [
        5648
    ],
    "ym": [
        5656
    ],
    "yongning na": [
        5678
    ],
    "yongning": [
        5678
    ],
    "yuan-mo yi": [
        5684,
        8953
    ],
    "yuan-mo": [
        5684,
        8953
    ],
    "yiru": [
        5700
    ],
    "yuanga": [
        5725
    ],
    "yuaanga": [
        5725
    ],
    "yuaga": [
        5725
    ],
    "yingkwira": [
        5750
    ],
    "yahurmene": [
        5765
    ],
    "yeu": [
        5798
    ],
    "yoe": [
        5798,
        8882,
        7368
    ],
    "yungwe": [
        5807
    ],
    "yo": [
        7865,
        7866,
        5809,
        9115
    ],
    "yinjebi": [
        5813
    ],
    "yinzebi": [
        5813
    ],
    "yinzébi": [
        5813
    ],
    "yhuata": [
        5907
    ],
    "yudhia": [
        5948,
        5949
    ],
    "yųhų": [
        5987
    ],
    "yühmu": [
        5997
    ],
    "yuwe": [
        6043,
        8225
    ],
    "yay": [
        6062,
        6063,
        8882,
        6845,
        6846,
        6847,
        6848
    ],
    "yine": [
        6143
    ],
    "yineri tokani": [
        6143
    ],
    "yineri": [
        6143
    ],
    "yineru tokanu": [
        6143
    ],
    "yineru": [
        6143
    ],
    "yinerï": [
        6143
    ],
    "yapoco": [
        6155
    ],
    "yaberoo": [
        6231
    ],
    "yokaia": [
        6259
    ],
    "yousafzai pashto": [
        6306
    ],
    "yousafzai": [
        6306
    ],
    "yusufzai pashto": [
        6306
    ],
    "yusufzai": [
        6306
    ],
    "yajich": [
        6358
    ],
    "yipounou": [
        6370
    ],
    "yipunu": [
        6370
    ],
    "yi-punu": [
        6370
    ],
    "yasa": [
        8822,
        6374
    ],
    "yanahuanca pasco quechua": [
        6409
    ],
    "yanahuanca": [
        6409
    ],
    "yumbo": [
        6412,
        6424
    ],
    "yauyos": [
        6413
    ],
    "yauyos quechua": [
        6413
    ],
    "yaurawa": [
        6503
    ],
    "yahang": [
        6516
    ],
    "ya’unk": [
        6516
    ],
    "yang lang": [
        6523
    ],
    "yang wan kun": [
        6523
    ],
    "yanglam": [
        6523
    ],
    "yin net": [
        6523
    ],
    "yinnet": [
        6523
    ],
    "yakuy": [
        6527
    ],
    "yawkum-yere": [
        6538
    ],
    "yurats": [
        6608
    ],
    "yaeyama": [
        6647
    ],
    "yayeyama": [
        6647
    ],
    "yakut": [
        6664,
        6665
    ],
    "yakut-sakha": [
        6664,
        6665
    ],
    "yholmo": [
        6732,
        7279
    ],
    "yohlmo": [
        6732
    ],
    "yolmo": [
        6732
    ],
    "yatí": [
        6734,
        6735
    ],
    "yanam": [
        6831
    ],
    "yirhe": [
        6873
    ],
    "yirhee": [
        6873
    ],
    "yosemite": [
        6915
    ],
    "yakiba": [
        6931
    ],
    "yui": [
        6949
    ],
    "yisangou": [
        7008
    ],
    "yisangu": [
        7008
    ],
    "yembe": [
        7039
    ],
    "yeyeza": [
        7127
    ],
    "yarawe": [
        7190
    ],
    "yarawi": [
        7190
    ],
    "yema": [
        7190
    ],
    "yichira": [
        7237
    ],
    "yholmoli": [
        7279
    ],
    "yholmu": [
        7279
    ],
    "yami": [
        7314
    ],
    "yukan": [
        7324,
        7325,
        7326
    ],
    "yumbar": [
        7363
    ],
    "yumplatok": [
        7371
    ],
    "yang hwang": [
        7372
    ],
    "yanghuang": [
        7372
    ],
    "yunannese shan": [
        7386,
        7387
    ],
    "yunannese": [
        7386,
        7387
    ],
    "yunnan shant’ou": [
        7386,
        7387
    ],
    "yangathimri": [
        7523
    ],
    "yedna miz": [
        7547,
        7548
    ],
    "yedna": [
        7547,
        7548
    ],
    "yikbi": [
        7547,
        7548
    ],
    "yiksum": [
        7547,
        7548
    ],
    "yiqny miz": [
        7547,
        7548
    ],
    "yiqny": [
        7547,
        7548
    ],
    "yiqsum": [
        7547,
        7548
    ],
    "yıqbışda miz": [
        7547,
        7548
    ],
    "yıqbışda": [
        7547,
        7548
    ],
    "yecuatla": [
        7562
    ],
    "yecuatla totonac": [
        7562
    ],
    "yibwa": [
        7606
    ],
    "yav ba": [
        7608
    ],
    "yav": [
        7608
    ],
    "yautefa": [
        7763
    ],
    "yotafa": [
        7763
    ],
    "yoroni": [
        7795
    ],
    "yuron": [
        7795
    ],
    "ye’pãmasa": [
        7796
    ],
    "yiive": [
        7929
    ],
    "yak": [
        7943
    ],
    "yintjingga": [
        7959,
        7960
    ],
    "yaugiba": [
        8011
    ],
    "yuenan-yu": [
        8078,
        8079,
        8080
    ],
    "yungur": [
        8132,
        8695,
        8934
    ],
    "yivoumbou": [
        8143
    ],
    "yote": [
        8149
    ],
    "yanomámi": [
        8194
    ],
    "yanoam": [
        8194
    ],
    "yanomama": [
        8194
    ],
    "yanomamé": [
        8194
    ],
    "yanomamõ": [
        8194
    ],
    "yaffi": [
        8216
    ],
    "yafi": [
        8216
    ],
    "yuwei": [
        8225
    ],
    "yu we": [
        8225
    ],
    "yu wei": [
        8225
    ],
    "yumpia": [
        8272
    ],
    "yor": [
        8616,
        8275
    ],
    "yallof": [
        8302,
        8303
    ],
    "yunnalinka": [
        8323
    ],
    "yangibaia": [
        8332
    ],
    "yeidji": [
        8361
    ],
    "yeithi": [
        8361
    ],
    "yoabou": [
        8375
    ],
    "yoabu": [
        8375
    ],
    "yabaroo": [
        8381
    ],
    "yarra yarra": [
        8384
    ],
    "yarra": [
        8384
    ],
    "yadymadhang": [
        8491
    ],
    "yare": [
        8509
    ],
    "yarsi": [
        8509
    ],
    "yur": [
        8616
    ],
    "yungar": [
        8619,
        8695
    ],
    "yitha yitha": [
        8651
    ],
    "yitha": [
        8651
    ],
    "yetho": [
        8651
    ],
    "yit-tha": [
        8651
    ],
    "yitsa": [
        8651
    ],
    "yosoyúa": [
        8654
    ],
    "yoloxóchitl": [
        8667
    ],
    "yoloxochitl mixtec": [
        8667
    ],
    "yoloxochitl": [
        8667
    ],
    "yarr": [
        8676
    ],
    "yooadda": [
        8695
    ],
    "yooard": [
        8695
    ],
    "yoongar": [
        8695
    ],
    "yuard": [
        8695
    ],
    "yuatjek": [
        8695
    ],
    "yamba": [
        8731,
        8701
    ],
    "yambayamba": [
        8701
    ],
    "yowewnillurn": [
        8701
    ],
    "yuppila": [
        8701
    ],
    "yaygir": [
        8707
    ],
    "yaygirr": [
        8707
    ],
    "yegera": [
        8707
    ],
    "yegir": [
        8707
    ],
    "yiegera": [
        8707
    ],
    "youngai": [
        8707
    ],
    "yandjibara": [
        8708
    ],
    "yalakalore": [
        8711
    ],
    "yorta yorta": [
        8713
    ],
    "yorta": [
        8713
    ],
    "yoorta": [
        8713,
        8960
    ],
    "yota yota": [
        8713
    ],
    "yota": [
        8713
    ],
    "yotayota": [
        8713
    ],
    "yaminahua": [
        8717
    ],
    "yaminawá": [
        8717
    ],
    "yamanawa": [
        8717
    ],
    "yuminahua": [
        8717
    ],
    "yuhup": [
        8718
    ],
    "yahup": [
        8718
    ],
    "yahup makú": [
        8718
    ],
    "yuhupdeh": [
        8718
    ],
    "yëhup": [
        8718
    ],
    "yali, pass valley": [
        8719
    ],
    "yaly": [
        8719
    ],
    "yagua": [
        8720
    ],
    "yahua": [
        8720
    ],
    "yava": [
        8720,
        8943
    ],
    "yawa": [
        8943,
        8720,
        8945
    ],
    "yegua": [
        8720
    ],
    "yaruro": [
        8721
    ],
    "yaruru": [
        8721
    ],
    "yuapín": [
        8721
    ],
    "yaka (democratic republic of congo)": [
        8722
    ],
    "yámana": [
        8723
    ],
    "yaghan": [
        8723
    ],
    "yagán": [
        8723
    ],
    "yahgan": [
        8723
    ],
    "yazgulyam": [
        8724,
        8725
    ],
    "yazghulomi": [
        8724,
        8725
    ],
    "yazgulam": [
        8724,
        8725
    ],
    "yazgulami": [
        8724,
        8725
    ],
    "yazgulyami": [
        8724,
        8725
    ],
    "yuzdomi zavég": [
        8724,
        8725
    ],
    "yuzdomi": [
        8724,
        8725
    ],
    "yagnobi": [
        8726
    ],
    "yaghnabi": [
        8726
    ],
    "yaghnobi": [
        8726
    ],
    "yaghnubi": [
        8726
    ],
    "yagnabi": [
        8726
    ],
    "yagnob": [
        8726
    ],
    "yagnubi": [
        8726
    ],
    "yangere": [
        8727
    ],
    "yanguere": [
        8727
    ],
    "yakama": [
        8728
    ],
    "yakima": [
        8728
    ],
    "yalunka": [
        8729,
        8730
    ],
    "yalunke": [
        8729,
        8730
    ],
    "yawo": [
        8733,
        8734
    ],
    "yapese": [
        8735
    ],
    "yaqui": [
        8736
    ],
    "yoeme": [
        8736
    ],
    "yoem noki": [
        8736
    ],
    "yoem": [
        8736
    ],
    "yabarana": [
        8737,
        8756
    ],
    "yauarana": [
        8737
    ],
    "yavarana": [
        8737
    ],
    "yawarana": [
        8737
    ],
    "yambasa": [
        8738
    ],
    "yambeta": [
        8739
    ],
    "yambetta": [
        8739
    ],
    "yoana": [
        8740
    ],
    "yuana": [
        8740
    ],
    "yuwana": [
        8740
    ],
    "yangben": [
        8741
    ],
    "yawalapití": [
        8742
    ],
    "yaulapiti": [
        8742
    ],
    "yauma": [
        8743
    ],
    "yakurr": [
        8745
    ],
    "yakö": [
        8745
    ],
    "yala": [
        8746,
        8858
    ],
    "yemba": [
        8747
    ],
    "yugur, west": [
        8748,
        8749
    ],
    "yugur": [
        8748,
        8749,
        8941
    ],
    "yogur": [
        8748,
        8749,
        8941
    ],
    "ya lu": [
        8748,
        8749
    ],
    "yellow uighur": [
        8748,
        8749,
        8941
    ],
    "yugu": [
        8748,
        8749,
        8941
    ],
    "yuku": [
        8748,
        8749
    ],
    "yakha": [
        8750
    ],
    "yakkha ceya": [
        8750
    ],
    "yakkhaba sala": [
        8750
    ],
    "yakthomba": [
        8750
    ],
    "yamphu kha": [
        8751
    ],
    "yamphu rai": [
        8751
    ],
    "yangphu": [
        8751
    ],
    "yashi": [
        8752
    ],
    "yukuben": [
        8754
    ],
    "yaben": [
        8755
    ],
    "yabaâna": [
        8756
    ],
    "yabaána": [
        8756
    ],
    "yabong": [
        8757
    ],
    "yawiyo": [
        8758
    ],
    "yabio": [
        8758
    ],
    "yaweyuha": [
        8759
    ],
    "yabiyufa": [
        8759
    ],
    "yawiyuha": [
        8759
    ],
    "yucuna": [
        8762
    ],
    "yucuna-matapí": [
        8762
    ],
    "yukuna": [
        8762
    ],
    "yunda": [
        8764
    ],
    "yangum dey": [
        8765
    ],
    "yangum": [
        8765,
        8783,
        8851
    ],
    "yadgha": [
        8766
    ],
    "yidga": [
        8766
    ],
    "yidgha": [
        8766
    ],
    "yudga": [
        8766
    ],
    "yudgha": [
        8766
    ],
    "yoidik": [
        8767
    ],
    "yerava": [
        8768,
        8769
    ],
    "yoruba": [
        8869,
        8870,
        8871,
        8872,
        8768,
        8769
    ],
    "yeniche": [
        8770
    ],
    "yenishe": [
        8770
    ],
    "yimas": [
        8771
    ],
    "yeni": [
        8772
    ],
    "yevanic": [
        8773
    ],
    "yevanitika": [
        8773
    ],
    "yela": [
        8774,
        8829
    ],
    "yergam": [
        8775
    ],
    "yergem": [
        8775
    ],
    "yergum": [
        8775
    ],
    "yasgua": [
        8776
    ],
    "yeskwa": [
        8776
    ],
    "yetfa": [
        8777
    ],
    "yetfa ma": [
        8777
    ],
    "yerukula": [
        8778
    ],
    "yarukula": [
        8778
    ],
    "yerkula": [
        8778
    ],
    "yerukala": [
        8778
    ],
    "yerukala-korava": [
        8778
    ],
    "yerukla": [
        8778
    ],
    "yerukula-bhasha": [
        8778
    ],
    "yeri": [
        8779
    ],
    "yapunda": [
        8779
    ],
    "yeyi": [
        8780
    ],
    "yeei": [
        8780
    ],
    "yiningayi": [
        8782
    ],
    "yiningay": [
        8782
    ],
    "yangum gel": [
        8783
    ],
    "yagomi": [
        8784
    ],
    "yagaria": [
        8786
    ],
    "yolngu sign language": [
        8787
    ],
    "ysl": [
        8787,
        8906
    ],
    "yolŋu sign language": [
        8787
    ],
    "yolŋu": [
        8787
    ],
    "yugul": [
        8788
    ],
    "yikil": [
        8788
    ],
    "yikul": [
        8788
    ],
    "yookil": [
        8788
    ],
    "yookull": [
        8788
    ],
    "yukul": [
        8788
    ],
    "yagwoia": [
        8789
    ],
    "yeghuye": [
        8789
    ],
    "yahudic": [
        8791
    ],
    "yan-nhangu sign language": [
        8793
    ],
    "ynsl": [
        8793
    ],
    "yan-nhaŋu sign language": [
        8793
    ],
    "yan-nhaŋu": [
        8793
    ],
    "yiddish": [
        8794,
        8798
    ],
    "yiddish, eastern": [
        8794
    ],
    "yidish": [
        8794,
        8798
    ],
    "yinggarda": [
        8795
    ],
    "yingkarta": [
        8795
    ],
    "yiddish, western": [
        8798
    ],
    "yidiny": [
        8799
    ],
    "yetinji": [
        8799
    ],
    "yiddinji": [
        8799
    ],
    "yidin": [
        8799
    ],
    "yidindji": [
        8799
    ],
    "yidini": [
        8799
    ],
    "yidinj": [
        8799
    ],
    "yitintyi": [
        8799
    ],
    "yukkaburra": [
        8799
    ],
    "yindjibarndi": [
        8800
    ],
    "yindjinbarndi": [
        8800
    ],
    "yinjtjipartnti": [
        8800
    ],
    "yindjilandji": [
        8802
    ],
    "yinjilanji": [
        8802
    ],
    "yimchungru": [
        8803
    ],
    "yachumi": [
        8803
    ],
    "yanchunger": [
        8803
    ],
    "yimchunger": [
        8803
    ],
    "yimchungre": [
        8803
    ],
    "yimchungru naga": [
        8803
    ],
    "yimchungrü": [
        8803
    ],
    "yang lai": [
        8804
    ],
    "yin kya": [
        8804
    ],
    "yinchia": [
        8804
    ],
    "yinja": [
        8804
    ],
    "yair": [
        8807
    ],
    "yis": [
        8808
    ],
    "yakan": [
        8814,
        8815
    ],
    "yacan": [
        8814,
        8815
    ],
    "yukaghir, northern": [
        8816
    ],
    "yukaghir": [
        8816,
        8940
    ],
    "yukagir": [
        8816,
        8940
    ],
    "yoke": [
        8817
    ],
    "yauke": [
        8817
    ],
    "yoki": [
        8817
    ],
    "yakaikeke": [
        8818
    ],
    "yakamul": [
        8820
    ],
    "yassa": [
        8822
    ],
    "yekora": [
        8823
    ],
    "yakoma": [
        8826
    ],
    "yaul": [
        8827
    ],
    "yélî dnye": [
        8829
    ],
    "yélî": [
        8829
    ],
    "yelatnye": [
        8829
    ],
    "yele": [
        8829
    ],
    "yelejong": [
        8829
    ],
    "yeletnye": [
        8829
    ],
    "yelidnye": [
        8829
    ],
    "yalaku": [
        8830
    ],
    "yelogu": [
        8830
    ],
    "yali, angguruk": [
        8831
    ],
    "yalimo": [
        8831
    ],
    "yil": [
        8832
    ],
    "yalarnnga": [
        8836
    ],
    "yalarrnga": [
        8836
    ],
    "yelina": [
        8836
    ],
    "yellanga": [
        8836
    ],
    "yellunga": [
        8836
    ],
    "yalu": [
        8837
    ],
    "yalasu": [
        8838
    ],
    "yalayu": [
        8838
    ],
    "yambes": [
        8839
    ],
    "yameo": [
        8842
    ],
    "yaméo": [
        8842
    ],
    "yamongeri": [
        8843
    ],
    "yamongiri": [
        8843
    ],
    "yamalele": [
        8848
    ],
    "yamna": [
        8850
    ],
    "yangum mon": [
        8851
    ],
    "yamap": [
        8852
    ],
    "yandruwandha": [
        8859
    ],
    "yango": [
        8861
    ],
    "yupik, naukan": [
        8862
    ],
    "yangulam": [
        8863
    ],
    "yana": [
        8864
    ],
    "yendang": [
        8866
    ],
    "yadang": [
        8866
    ],
    "yandang": [
        8866
    ],
    "yendam": [
        8866
    ],
    "yundum": [
        8866
    ],
    "yans": [
        8867
    ],
    "yansi": [
        8867
    ],
    "yahuna": [
        8868
    ],
    "yayuna": [
        8868
    ],
    "yaúna": [
        8868
    ],
    "yorùbá": [
        8869,
        8870,
        8871,
        8872
    ],
    "yariba": [
        8869,
        8870,
        8872
    ],
    "yooba": [
        8869,
        8870,
        8872
    ],
    "yorouba": [
        8869,
        8870,
        8872
    ],
    "yoba": [
        8873
    ],
    "yogad": [
        8874
    ],
    "yonaguni": [
        8875
    ],
    "yokuts": [
        8876
    ],
    "yaudanchi": [
        8876
    ],
    "yaudanchi yokuts": [
        8876
    ],
    "yokutsan": [
        8876
    ],
    "yombe": [
        8878
    ],
    "yoombe": [
        8878
    ],
    "yotti": [
        8880
    ],
    "yoti": [
        8880
    ],
    "yoron": [
        8881
    ],
    "yoy": [
        8882
    ],
    "yuai": [
        8882
    ],
    "yoi": [
        8882
    ],
    "yooi": [
        8882
    ],
    "yooy": [
        8882
    ],
    "yueai": [
        8882
    ],
    "yerakai": [
        8892
    ],
    "yerekai": [
        8892
    ],
    "yareba": [
        8893
    ],
    "yaouré": [
        8894
    ],
    "yɔwlɛ": [
        8894
    ],
    "yaure": [
        8894
    ],
    "yohowré": [
        8894
    ],
    "youré": [
        8894
    ],
    "yurak": [
        8895
    ],
    "yurak samoyed": [
        8895
    ],
    "yeral": [
        8896
    ],
    "yirrk-mel": [
        8897
    ],
    "yir mel": [
        8897
    ],
    "yirmel": [
        8897
    ],
    "yirr-mel": [
        8897
    ],
    "yirr-thangell": [
        8897
    ],
    "yirrk-thangalki": [
        8897
    ],
    "yerong": [
        8898
    ],
    "yalang": [
        8898
    ],
    "yang khyung": [
        8898
    ],
    "yerong buyang": [
        8898
    ],
    "yaroamë": [
        8899
    ],
    "yawari": [
        8899
    ],
    "yarsun": [
        8900
    ],
    "yarawata": [
        8901
    ],
    "yarluyandi": [
        8902
    ],
    "yarleeyandee": [
        8902
    ],
    "yelyuyendi": [
        8902
    ],
    "yassic": [
        8903
    ],
    "yugoslav sign language": [
        8906
    ],
    "yugoslav": [
        8906
    ],
    "yugoslavian sign language": [
        8906
    ],
    "yugoslavian": [
        8906
    ],
    "yupik, sirenik": [
        8911
    ],
    "yessan-mayo": [
        8912
    ],
    "yamano": [
        8912
    ],
    "yasyin": [
        8912
    ],
    "yesan": [
        8912
    ],
    "yout wam": [
        8917
    ],
    "yout": [
        8917
    ],
    "yatay": [
        8918
    ],
    "yucantán maya": [
        8919
    ],
    "yucantán": [
        8919
    ],
    "yucatan maya": [
        8919
    ],
    "yucatan": [
        8919
    ],
    "yucatec maya": [
        8919
    ],
    "yucateco": [
        8919
    ],
    "yukatek": [
        8919
    ],
    "yugambal": [
        8920
    ],
    "yugabeh": [
        8920
    ],
    "yugambeh": [
        8920
    ],
    "yugumbal": [
        8920
    ],
    "yuchi": [
        8921
    ],
    "yuchee": [
        8921
    ],
    "yudi": [
        8922
    ],
    "yue chinese": [
        8923,
        8924,
        8925,
        8926
    ],
    "yueh": [
        8923,
        8924,
        8925,
        8926
    ],
    "yuet": [
        8923,
        8924,
        8925,
        8926
    ],
    "yuet yue": [
        8923,
        8924,
        8925,
        8926
    ],
    "yueyu": [
        8923,
        8924,
        8925,
        8926
    ],
    "yuht yúh": [
        8923,
        8924,
        8925,
        8926
    ],
    "yuht": [
        8923,
        8924,
        8925,
        8926
    ],
    "yúh": [
        8923,
        8924,
        8925,
        8926
    ],
    "yug": [
        8928
    ],
    "yugh": [
        8928
    ],
    "yugi": [
        8928
    ],
    "yuriti": [
        8929
    ],
    "yuriti-tapuia": [
        8929
    ],
    "yuruti": [
        8929
    ],
    "yuruti-tapuya": [
        8929
    ],
    "yurutiye": [
        8929
    ],
    "yurutí": [
        8929
    ],
    "yuki": [
        8931,
        8936
    ],
    "yukian": [
        8931
    ],
    "yulu": [
        8932
    ],
    "youlou": [
        8932
    ],
    "yuma": [
        8933
    ],
    "yangeru": [
        8934
    ],
    "yangur": [
        8934
    ],
    "yongor": [
        8934
    ],
    "yungirba": [
        8934
    ],
    "yukpa": [
        8935
    ],
    "yuco": [
        8935
    ],
    "yucpa": [
        8935
    ],
    "yuko": [
        8935
    ],
    "yukpa-japería": [
        8935
    ],
    "yupa": [
        8935
    ],
    "yuqui": [
        8936
    ],
    "yë": [
        8936
    ],
    "yurok": [
        8937
    ],
    "yopno": [
        8938
    ],
    "yupna": [
        8938
    ],
    "yaö": [
        8939
    ],
    "yau (morobe province)": [
        8939
    ],
    "yukaghir, southern": [
        8940
    ],
    "yugur, east": [
        8941
    ],
    "yogor": [
        8941
    ],
    "yughur": [
        8941
    ],
    "yugar": [
        8941
    ],
    "yögur": [
        8941
    ],
    "yuracare": [
        8942
    ],
    "yuracar": [
        8942
    ],
    "yurakar": [
        8942
    ],
    "yurakaré": [
        8942
    ],
    "yurucare": [
        8942
    ],
    "yurujare": [
        8942
    ],
    "yurujuré": [
        8942
    ],
    "yawa unat": [
        8943
    ],
    "yapanani": [
        8943
    ],
    "yavitano": [
        8944
    ],
    "yinhawangka": [
        8946
    ],
    "yawanawa": [
        8948
    ],
    "yahuanahua": [
        8948
    ],
    "yauanauá": [
        8948
    ],
    "yi, wuding-luquan": [
        8949,
        8950
    ],
    "yawuru": [
        8951
    ],
    "yawarawarga": [
        8954
    ],
    "yawarrawarrka": [
        8954
    ],
    "yagara": [
        8956
    ],
    "yackarabul": [
        8956
    ],
    "yaggara": [
        8956
    ],
    "yerongban": [
        8956
    ],
    "yeronghan": [
        8956
    ],
    "yerongpan": [
        8956
    ],
    "yugara": [
        8956
    ],
    "yugg-ari": [
        8956
    ],
    "yuggara": [
        8956
    ],
    "yardliyawarra": [
        8957
    ],
    "yadliaura": [
        8957
    ],
    "yadlikowera": [
        8957
    ],
    "yadliura": [
        8957
    ],
    "yadliyawarra": [
        8957
    ],
    "yadlouri": [
        8957
    ],
    "yaldikowera": [
        8957
    ],
    "yardliwarra": [
        8957
    ],
    "yardliyawara": [
        8957
    ],
    "yinwum": [
        8958
    ],
    "yeemwoom": [
        8958
    ],
    "yuyu": [
        8959
    ],
    "yerraruck": [
        8959
    ],
    "yiran": [
        8959
    ],
    "yirau": [
        8959
    ],
    "you-you": [
        8959
    ],
    "yabula yabula": [
        8960
    ],
    "yabula": [
        8960
    ],
    "yabala-yabala": [
        8960
    ],
    "yabbil-yabbila": [
        8960
    ],
    "yabbilyabbila": [
        8960
    ],
    "yabola": [
        8960
    ],
    "yabula-yabula": [
        8960
    ],
    "yabulla": [
        8960
    ],
    "yillib-yilliba": [
        8960
    ],
    "yullaba yullaba": [
        8960
    ],
    "yullaba": [
        8960
    ],
    "yir-yoront": [
        8961
    ],
    "yir yiront": [
        8961
    ],
    "yiront": [
        8961
    ],
    "yir yoront": [
        8961
    ],
    "yoront": [
        8961
    ],
    "yir-yiront": [
        8961
    ],
    "yau (sandaun province)": [
        8962
    ],
    "yongbei": [
        8966,
        8967
    ],
    "yaganiza zapotec": [
        8972
    ],
    "yaganiza": [
        8972
    ],
    "yareni": [
        8973
    ],
    "yareni zapotec": [
        8973
    ],
    "yaeé": [
        8986
    ],
    "yagallo": [
        8986
    ],
    "yatzachi": [
        8990
    ],
    "yatzachi zapotec": [
        8990
    ],
    "yan-guang southern zhuang": [
        9047,
        9048
    ],
    "yan-guang": [
        9047,
        9048
    ],
    "yos": [
        9115
    ],
    "yautepec": [
        9121,
        9128,
        9129,
        9130
    ],
    "yautepec zapotec": [
        9121
    ],
    "yavesía zapotec": [
        9123
    ],
    "yavesía": [
        9123
    ],
    "yatzechi": [
        9133
    ],
    "yalálag": [
        9140
    ],
    "yàlhálhg": [
        9140
    ],
    "yalálag zapotec": [
        9140
    ],
    "yatee": [
        9171
    ],
    "yatee zapotec": [
        9171
    ],
    "yufiyufa": [
        9175
    ],
    "yang zhuang": [
        9181
    ],
    "yangx": [
        9181
    ],
    "yangyu": [
        9181
    ],
    "yangzhou": [
        9181
    ],
    "youjiang": [
        9182,
        9183
    ],
    "youjiang zhuang": [
        9182,
        9183
    ],
    "yongnan": [
        9184
    ],
    "yongnan vernacular of the southern dialect of the zhuang language": [
        9184
    ],
    "yongnan zhuang": [
        9184
    ]
};
